import React from 'react';

import Css from './JsiLogo.scss';
import ImportImages from '@src/importImages';

const JsiLogo = ImportImages('/jsi-logo.png');

const jsiLogo = props => {
  return (
    <div
      className={Css['jsi-logo'] + ' ' + props.className}
      style={props.style}
    >
      <img src={JsiLogo} alt={'Jsi Logo'} />
    </div>
  );
};

export default jsiLogo;



// WEBPACK FOOTER //
// ./src/components/JsiLogo/JsiLogo.js